import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  DeleteApiKeyMutation,
  DeleteApiKeyMutationVariables,
} from '../../../shared/generated/graphql';

const DELETE_API_KEY = gql`
  mutation DeleteAPIKey($id: String!) {
    deleteAPIKeyDefinition(id: $id) {
      id
    }
  }
`;

export const useRevokeAPIKey = (
  options?: MutationHookOptions<
    DeleteApiKeyMutation,
    DeleteApiKeyMutationVariables
  >,
) => {
  return useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(
    DELETE_API_KEY,
    {
      errorPolicy: 'all',
      ...options,
    },
  );
};
